import { useQuery } from 'react-query';
import ItemServiceApi from '../../Api/item-service';
import { VendorCatalogItem } from './types';

export const useGetVendorItem = (userId: string, itemId: string) =>
  useQuery<VendorCatalogItem>(
    ['item-service-vendor-catalog-item', userId, itemId],
    async () => ItemServiceApi.getVendorItem(userId, itemId),
  );
